import { Box } from '@mui/material';

type TextOverflowHiddenProps = {
  children: string;
  maxWidth?: number;
};

export const TextOverflowHidden = (props: TextOverflowHiddenProps) => {
  const { children, maxWidth = 200 } = props;
  return (
    <Box
      sx={{
        maxWidth, // percentage also works
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      title={children}
    >
      {children}
    </Box>
  );
};
